module.exports = __webpack_public_path__ + "img/rhymeswith.106d90c6.png";